import { FilterBar } from '@shared/search';
import { sessionSchema } from './sessionSchema';
import { useI18n } from '@/context/I18nContext';

interface SearchBarProps {
  initialQuery: string;
  onSearch: (query: string) => void;
  enableFilterUI?: boolean;
}

export function SearchBar({ initialQuery, onSearch, enableFilterUI = true }: SearchBarProps) {
  const { t } = useI18n();

  return (
    <FilterBar
      initialQuery={initialQuery}
      schema={sessionSchema}
      onSearch={onSearch}
      placeholder={t('search.placeholder')}
      enableFilterUI={enableFilterUI}
    />
  );
}
